import { useEffect } from 'react';

import {
	setUpEditorInlineCommentsPubSub,
	removeEditorInlineCommentsPubSub,
} from '@confluence/comments-pubsub/entry-points/inlineComments';

type PubSubProps = {
	contentId: string;
	contentType: string;
	triggerAnalyticsEvent: (
		eventName: string,
		extraData?: {
			[key: string]: any;
		},
	) => Promise<void>;
	updateUnresolvedInlineComment: (unresolvedInlineComments: string[]) => void;
	isDocumentActive: boolean;
	annotations: string[];
};

export const useEditorInlineCommentsPubSub = ({
	contentId,
	contentType,
	triggerAnalyticsEvent,
	updateUnresolvedInlineComment,
	isDocumentActive,
	annotations,
}: PubSubProps) => {
	useEffect(() => {
		const pubSubProps = {
			contentId,
			contentType,
			getEditorAnnotations: () => annotations,
			triggerAnalyticsEvent,
			updateUnresolvedInlineComment,
		};

		setUpEditorInlineCommentsPubSub(pubSubProps);

		return () => removeEditorInlineCommentsPubSub({ contentId, contentType });

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		contentId,
		contentType,
		triggerAnalyticsEvent,
		updateUnresolvedInlineComment,
		isDocumentActive,
		annotations,
	]);
};
